/* eslint-disable react/prop-types */

// Speech balloon with a drawn tail. The tail path is open on the side that meets
// the balloon and overlaps its line, so the outline reads as one continuous stroke.
// `tail`: 'down' (speaker below), 'left' (speaker beside it), or 'auto' (down on phones, left from md).
const TAILS = {
  down: {
    className: 'left-10 top-[calc(100%-var(--stroke)-1px)] h-8 w-9',
    viewBox: '0 0 32 30',
    d: 'M2 0 6 28 30 0',
  },
  left: {
    className: 'right-[calc(100%-var(--stroke)-1px)] top-7 h-9 w-8',
    viewBox: '0 0 30 32',
    d: 'M30 2 2 6 30 30',
  },
}

const Balloon = ({ as: Tag = 'div', tail = 'down', className = '', children, ...rest }) => {
  const tails =
    tail === 'auto'
      ? [
          ['down', 'md:hidden'],
          ['left', 'hidden md:block'],
        ]
      : [[tail, '']]
  return (
    <Tag className={`balloon ${className}`} {...rest}>
      {children}
      {tails.map(([name, show]) => (
        <svg
          key={name}
          aria-hidden='true'
          viewBox={TAILS[name].viewBox}
          className={`absolute ${TAILS[name].className} ${show}`}
        >
          <path d={TAILS[name].d} className='fill-paper stroke-coal' strokeWidth='3' strokeLinejoin='round' />
        </svg>
      ))}
    </Tag>
  )
}

export default Balloon
